const STORAGE_PREFIX = 'createBriefState:';

function getStorageKey(storySlug) {
    return `${STORAGE_PREFIX}${storySlug}`;
}

export function loadPersistedBriefState(storySlug) {
    if (!storySlug || typeof window === 'undefined') return null;

    try {
        const rawState = window.sessionStorage.getItem(getStorageKey(storySlug));
        if (!rawState) return null;

        const parsedState = JSON.parse(rawState);
        if (!parsedState || typeof parsedState !== 'object') return null;

        return parsedState;
    } catch (error) {
        console.warn('Failed to load persisted brief state:', error);
        return null;
    }
}

export function persistBriefState(storySlug, briefState) {
    if (!storySlug || !briefState || typeof window === 'undefined') return;

    try {
        window.sessionStorage.setItem(getStorageKey(storySlug), JSON.stringify(briefState));
    } catch (error) {
        console.warn('Failed to persist brief state:', error);
    }
}

export function clearPersistedBriefState(storySlug) {
    if (!storySlug || typeof window === 'undefined') return;

    try {
        window.sessionStorage.removeItem(getStorageKey(storySlug));
    } catch (error) {
        console.warn('Failed to clear persisted brief state:', error);
    }
}